import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { defineComponent, computed, ref, reactive, onBeforeMount } from 'vue';
import Pagination from '@/components/Pagination/index.vue';
import SearchBar from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import AdvertisersDialog from './components/dialog/advertisers-dialog.vue';
import PriorityDialog from './components/dialog/priority-dialog.vue';
import searchMixin from '@/mixin/search';
import { parseTime } from '@/filters/index';
import { getWarningList, saveWarningInfo, updateWarningInfo, deleteWarningInfo, getRereviewSetting, editRereviewSetting, getPrioritySetting, IsUseReviewEnum, searchOptions } from '@/api/creative/warning';
import { getAppTagTree } from '@/api/common/apptag';
import _ from 'lodash';

var defaultDialogQuery = {
  third_tag_code: [],
  is_use_review: IsUseReviewEnum.NO,
  is_use_rereview: IsUseReviewEnum.NO,
  upd_review: true // 更新复审-true/巡审-false
};

export default defineComponent({
  mixins: [searchMixin],
  components: {
    SearchBar: SearchBar,
    TableList: TableList,
    Pagination: Pagination,
    PriorityDialog: PriorityDialog,
    AdvertisersDialog: AdvertisersDialog
  },
  setup: function setup(props, _ref) {
    var _this = this;

    var emit = _ref.emit;

    var pagination = reactive({
      total: 20
    });
    var dialogQuery = ref(_extends({}, defaultDialogQuery));

    // 对应搜索栏的数据
    var query = ref({
      page: 1,
      page_size: 15,
      third_tag_code: [],
      is_use_review: '',
      is_use_rereview: '',
      createTime: [],
      updateTime: []
    });
    // 搜索请求数据：对query数据进行处理
    var searchQuery = computed(function () {
      var create_start_date = '';
      var create_end_date = '';
      var update_start_date = '';
      var update_end_date = '';
      if (query.value.createTime.length === 2) {
        create_start_date = query.value.createTime[0];
        create_end_date = query.value.createTime[1];
      }
      if (query.value.updateTime.length === 2) {
        update_start_date = query.value.updateTime[0];
        update_end_date = query.value.updateTime[1];
      }
      return {
        page: query.value.page,
        page_size: query.value.page_size,
        third_tag_code: query.value.third_tag_code,
        is_use_review: query.value.is_use_review,
        is_use_rereview: query.value.is_use_rereview,
        create_start_date: create_start_date,
        create_end_date: create_end_date,
        update_start_date: update_start_date,
        update_end_date: update_end_date
      };
    });

    var tableConfig = {
      'row-key': 'id'

      // 产品标签下拉选择数据（树形）
    };var appTagList = ref([]);
    // 获取产品标签下拉选择数据
    var getAppTagList = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getAppTagTree();

              case 3:
                res = _context.sent;

                appTagList.value = (_.get(res, 'data.data') || []).map(function (item) {
                  return _extends({}, item, {
                    label: item.name,
                    value: item.code
                  });
                }) || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }));

      return function getAppTagList() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 页面列表数据
    var list = ref([]);
    var listLoading = ref(false);
    // 获取列表数据
    var getRenderList = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref4, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                listLoading.value = true;
                _context2.prev = 1;
                _context2.next = 4;
                return getWarningList(searchQuery.value);

              case 4:
                _ref4 = _context2.sent;
                data = _ref4.data;

                list.value = data.data.list || [];
                pagination.total = data.data.total;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);

              case 13:
                _context2.prev = 13;

                listLoading.value = false;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 10, 13, 16]]);
      }));

      return function getRenderList() {
        return _ref3.apply(this, arguments);
      };
    }();
    var tableColumnConfig = computed(function () {
      return [{
        label: 'ID',
        prop: 'id'
      }, {
        label: '产品一级标签',
        prop: 'first_tag'
      }, {
        label: '产品二级标签',
        prop: 'second_tag'
      }, {
        label: '产品三级标签',
        prop: 'third_tag'
      }, {
        label: '创建时间',
        prop: 'created_time',
        params: {
          innerText: function innerText(_ref5) {
            var row = _ref5.row;

            return parseTime(row.created_time, '{y}-{m}-{d} {h}:{i}') || '-';
          }
        }
      }, {
        label: '修改日期',
        prop: 'updated_time',
        params: {
          innerText: function innerText(_ref6) {
            var row = _ref6.row;

            return parseTime(row.updated_time, '{y}-{m}-{d} {h}:{i}') || '-';
          }
        }
      }, {
        label: '修改人',
        prop: 'admin_name'
      }, {
        label: '是否对复审生效',
        prop: 'is_use_review',
        params: {
          innerText: function innerText(_ref7) {
            var row = _ref7.row;

            if (row.id === 0) {
              return '-';
            }
            return row.is_use_review === IsUseReviewEnum.YES ? '是' : '否';
          }
        }
      }, {
        label: '是否对巡审生效',
        prop: 'is_use_rereview',
        params: {
          innerText: function innerText(_ref8) {
            var row = _ref8.row;

            if (row.id === 0) {
              return '-';
            }
            return row.is_use_rereview === IsUseReviewEnum.YES ? '是' : '否';
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    });

    var formItemList = computed(function () {
      var list = {
        third_tag_code: {
          label: '产品标签：',
          prop: 'third_tag_code',
          type: 'cascader',
          params: {
            props: {
              children: 'child',
              emitPath: false,
              label: 'name',
              value: 'code',
              multiple: true
            },
            options: appTagList.value,
            filterable: true,
            clearable: true,
            'show-all-levels': false,
            'collapse-tags': true,
            style: 'width: 300px;'
          }
        },
        createTime: {
          label: '创建时间:',
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'createTime',
          class: 'date-picker',
          params: {
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {}
          }
        },
        updateTime: {
          label: '修改时间:',
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'updateTime',
          class: 'date-picker',
          params: {
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {}
          }
        },
        is_use_review: {
          type: 'select',
          prop: 'is_use_review',
          params: {
            clearable: true,
            placeholder: '是否对复审生效',
            options: searchOptions
          }
        },
        is_use_rereview: {
          type: 'select',
          prop: 'is_use_rereview',
          params: {
            clearable: true,
            placeholder: '是否对巡审生效',
            options: searchOptions
          }
        }
      };
      return list;
    });

    // advertisersDialog对话框
    var advertisersDialog = reactive({
      visible: false,
      tagRow: null,
      title: '添加风险产品标签',
      rules: null
    });

    var thresholdDialog = reactive({
      visible: false,
      model: {},
      rules: {
        image: {
          check: function check(value) {
            if (_.isUndefined(value)) return false;
            return true;
          }
        },
        video: {
          check: function check(value) {
            if (_.isUndefined(value)) return false;
            return true;
          }
        },
        pl: {
          check: function check(value) {
            if (_.isUndefined(value)) return false;
            return true;
          }
        }
      }
    });

    var priorityDialog = reactive({
      visible: false,
      model: {}
    });

    // adv_dialog的schema
    var dialogSchema = computed(function () {
      var defProperties = {
        is_use_review: {
          title: '是否对复审生效：',
          component: 'select',
          visible: advertisersDialog.tagRow === null || dialogQuery.value.upd_review,
          rules: [{
            required: true,
            message: '请选择是否对复审生效'
          }],
          field: {
            style: 'width: 300px;',
            options: searchOptions
          }
        },
        is_use_rereview: {
          title: '是否对巡审生效：',
          component: 'select',
          visible: advertisersDialog.tagRow === null || !dialogQuery.value.upd_review,
          rules: [{
            required: true,
            message: '请选择是否对巡审生效'
          }],
          field: {
            style: 'width: 300px;',
            options: searchOptions
          }
        }
      };
      var properties = null;
      if (advertisersDialog.tagRow === null) {
        properties = _Object$assign({
          third_tag_code: {
            title: '产品标签：',
            component: 'cascader',
            rules: [{
              required: true,
              message: '请选择产品标签'
            }],
            field: {
              props: {
                children: 'child',
                emitPath: false,
                label: 'name',
                value: 'code',
                multiple: true
              },
              options: appTagList.value,
              filterable: true,
              clearable: true,
              'show-all-levels': false,
              'collapse-tags': true,
              style: 'width: 300px;'
            }
          }
        }, defProperties);
      } else {
        properties = defProperties;
      }

      return {
        type: 'object',
        properties: properties
      };
    });

    var thresholdSchema = computed(function () {
      return {
        type: 'object',
        properties: {
          image: {
            title: '图片：',
            component: 'input-number',
            field: {
              min: 0,
              controls: false,
              scrub: true,
              style: 'width: 300px;'
            },
            rules: [{
              required: true,
              message: '请设置图片阈值',
              trigger: 'blur'
            }]
          },
          video: {
            title: '视频：',
            component: 'input-number',
            field: {
              min: 0,
              controls: false,
              scrub: true,
              style: 'width: 300px;'
            },
            rules: [{
              required: true,
              message: '请设置视频阈值',
              trigger: 'blur'
            }]
          },
          pl: {
            title: 'PL：',
            component: 'input-number',
            field: {
              min: 0,
              controls: false,
              scrub: true,
              style: 'width: 300px;'
            },
            rules: [{
              required: true,
              message: '请设置PL阈值',
              trigger: 'blur'
            }]
          }
        }
      };
    });

    var handleOpenPriority = function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getPrioritySetting();

              case 3:
                res = _context3.sent;

                priorityDialog.model = _.get(res, 'data.data');
                priorityDialog.visible = true;
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[0, 8]]);
      }));

      return function handleOpenPriority() {
        return _ref9.apply(this, arguments);
      };
    }();

    var handleOpenThreshold = function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getRereviewSetting();

              case 3:
                res = _context4.sent;

                thresholdDialog.model = _.get(res, 'data.data');
                thresholdDialog.visible = true;
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this, [[0, 8]]);
      }));

      return function handleOpenThreshold() {
        return _ref10.apply(this, arguments);
      };
    }();

    var handleAddProduct = function handleAddProduct() {
      advertisersDialog.tagRow = null;
      advertisersDialog.title = '添加风险产品标签';

      dialogQuery.value = _extends({}, defaultDialogQuery);

      advertisersDialog.rules = {
        third_tag_code: {
          check: function check(value) {
            if (value.length < 1) return false;
            return true;
          }
        }
      };

      advertisersDialog.visible = true;
    };

    var handleEditReviewRule = function handleEditReviewRule(row, upd_review) {
      advertisersDialog.tagRow = row;
      dialogQuery.value.upd_review = upd_review;
      advertisersDialog.rules = null;

      if (upd_review) {
        advertisersDialog.title = '修改对复审生效';
        dialogQuery.value.is_use_review = row.is_use_review;
      } else {
        advertisersDialog.title = '修改对巡审生效';
        dialogQuery.value.is_use_rereview = row.is_use_rereview;
      }

      advertisersDialog.visible = true;
    };
    var handleDelete = function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var _ref12, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return deleteWarningInfo({ id: id });

              case 3:
                _ref12 = _context5.sent;
                data = _ref12.data;

                if (data.code === 0) {
                  getRenderList();
                }
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this, [[0, 8]]);
      }));

      return function handleDelete(_x) {
        return _ref11.apply(this, arguments);
      };
    }();
    var handleDialogSubmit = function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _params, params;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (advertisersDialog.tagRow) {
                  _context6.next = 6;
                  break;
                }

                _params = _extends({}, _.pick(dialogQuery.value, ['third_tag_code', 'is_use_review', 'is_use_rereview']));
                _context6.next = 5;
                return saveWarningInfo(_params);

              case 5:
                return _context6.abrupt('return', _context6.sent);

              case 6:
                params = {
                  id: advertisersDialog.tagRow.id,
                  upd_review: dialogQuery.value.upd_review
                };


                if (dialogQuery.value.upd_review) {
                  params.is_use_review = dialogQuery.value.is_use_review;
                } else {
                  params.is_use_rereview = dialogQuery.value.is_use_rereview;
                }
                _context6.next = 10;
                return updateWarningInfo(params);

              case 10:
                return _context6.abrupt('return', _context6.sent);

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0);

              case 16:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this, [[0, 13]]);
      }));

      return function handleDialogSubmit() {
        return _ref13.apply(this, arguments);
      };
    }();

    var handleThresholdSubmit = function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return editRereviewSetting(thresholdDialog.model);

              case 3:
                return _context7.abrupt('return', _context7.sent);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this, [[0, 6]]);
      }));

      return function handleThresholdSubmit() {
        return _ref14.apply(this, arguments);
      };
    }();

    onBeforeMount(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              getRenderList();
              getAppTagList();

            case 2:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    })));

    return {
      formItemList: formItemList,
      query: query,
      list: list,
      listLoading: listLoading,
      tableColumnConfig: tableColumnConfig,
      tableConfig: tableConfig,
      pagination: pagination,
      dialogSchema: dialogSchema,
      dialogQuery: dialogQuery,
      thresholdSchema: thresholdSchema,
      thresholdDialog: thresholdDialog,
      priorityDialog: priorityDialog,
      advertisersDialog: advertisersDialog,
      getRenderList: getRenderList,
      handleDelete: handleDelete,
      handleAddProduct: handleAddProduct,
      handleOpenPriority: handleOpenPriority,
      handleOpenThreshold: handleOpenThreshold,
      handleEditReviewRule: handleEditReviewRule,
      handleDialogSubmit: handleDialogSubmit,
      handleThresholdSubmit: handleThresholdSubmit
    };
  },

  watch: {
    $route: function $route() {
      this.getRenderList();
    }
  }
});